import { form } from 'stores';

import { SUPPORT_TASK_MANAGER_FORM } from '../constants';

export const isNewFormValue = (newInputValue: any, name: string): boolean => {
  const formValue = form.fetch<string>(SUPPORT_TASK_MANAGER_FORM, name) as any;
  return formValue?.label !== newInputValue;
};
